import React from "react";
import SearchResult from "../../model/SearchResult";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSubSections from "../../utils/AppSubSections";
import ImgUtil from "../../utils/ImgUtil";
import AppIcons from "../../utils/AppIcons";
import TimeUtil from "../../utils/TimeUtil";
import ButtonInfo from "../common/button/ButtonInfo";
import chemiNovaEntityTypeDisplay from "../../utils/ChemiNovaEntityTypeDisplay";
import uiSectionByEntityType from "../../utils/UISectionByEntityType";

interface ISearchResultsItemsProps {
  data: SearchResult;
}

function SearchResultsItems({ data }: ISearchResultsItemsProps) {
  // reference to the navigator
  const navigate = useNavigate();

  const searchResultClicked = (index: number) => {
    try {
      const clickedItem = data.items[index];
      const section = uiSectionByEntityType(clickedItem.entity_type);

      // we navigate only if we have a valid section to navigate to
      if (section) {
        navigate(
          SETTINGS.get_path({
            section: section,
            id: clickedItem.id,
            subsection: AppSubSections.VIEW,
          })
        );
      }
    } catch (exception) {}
  };

  return (
    <div>
      {data.items.map((item, index) => {
        return (
          <div onClick={() => searchResultClicked(index)} className="list-row">
            {item.icon && (
              <div
                className="list-row-icon"
                style={{
                  backgroundImage: `url(${ImgUtil.display_icon(item.icon)})`,
                }}
              ></div>
            )}
            <div className="list-row-content">
              <div className="list-row-header">
                <div className="list-row-title">
                  <h3>{item.name}</h3>
                </div>
              </div>

              <div className="list-row-description">{item.description}</div>
              <div className="list-row-footer">
                <ButtonInfo>
                  {AppIcons.getIconByEntityType(item.entity_type!)}
                  Entity type:{" "}
                  <span>
                    {chemiNovaEntityTypeDisplay(item.entity_type, true)}
                  </span>
                </ButtonInfo>
                <ButtonInfo>
                  {AppIcons.CLOCK}
                  Last update:{" "}
                  <span>{TimeUtil.display_date(item.created_on)}</span>
                </ButtonInfo>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SearchResultsItems;
